import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LoginService } from '../login/login.service';
import { appRoutes } from '../../../app/routes.constant';
import { UserService } from '../../services/user.service';
import { TagsService } from '../../services/tags.service';
import { LoginAuthService } from './login-auth.service';
import { nodeTypes } from '../../../app/app-constant'

@Component({
  selector: 'app-login-auth',
  templateUrl: './login-auth.component.html',
  styleUrls: ['./login-auth.component.css']
})
export class LoginAuthComponent implements OnInit {

  saml: any;
  samlAuth: boolean = true;
  //token: any;

  constructor(private activatedRoute: ActivatedRoute, private loginService: LoginService, private router: Router, private userService: UserService, 
    private tagsService: TagsService) { }

  ngOnInit() {
    let that = this;
    this.activatedRoute.queryParams.subscribe(params => {
      //console.log(params);
      //this.saml = params.saml;
      if(params.saml) {
        that.loginService.loggedIn = 'Y';
        that.userService.nodeType = 'ROLE_CUSTOMER';
        let landingRoute = that.loginService.getLandingRoute();
        that.router.navigate([landingRoute]);

        this.loginService.login({'saml': params.saml})
          .subscribe( res => {
            let landingRoute = this.loginService.getLandingRoute();
            this.router.navigate([landingRoute]);

            if(res.role == nodeTypes.ADMIN) {
              let landingRoute = this.loginService.getLandingRoute();
              this.router.navigate([landingRoute]);
            } else if(res.role == nodeTypes.CUSTOMER) {
              this.getUserData();
            } else {
              //this.incorrectUserPas = true;
              that.samlAuth = false;
            }
          },
          error => {
            that.samlAuth = false;
          });
      } else {
        that.samlAuth = false;
      }
    });

    //this.tagsService.view({});
  }

  getUserData(): void {
    let that = this;
    this.loginService.getUserData()
      .subscribe( res => {
          let landingRoute = this.loginService.getLandingRoute();
          this.router.navigate([landingRoute]);
		    },
        error => {
          //this.cordaError = error;
          //console.log(error);
          that.samlAuth = false;
        });
  }

}
